"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIframeContainer = exports.createWrapper = exports.createLoaderContainer = void 0;

var styles = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var createDiv = function createDiv(attributes) {
  var _attributes$animate, _attributes$animate2;

  var div = document.createElement("div");
  div.setAttribute("id", attributes.id);
  div.animate((_attributes$animate = attributes.animate) === null || _attributes$animate === void 0 ? void 0 : _attributes$animate.keyframes, (_attributes$animate2 = attributes.animate) === null || _attributes$animate2 === void 0 ? void 0 : _attributes$animate2.keyframeOptions);

  if (div.style) {
    Object.assign(div.style, attributes.style);
  }

  return div;
};

var createWrapper = function createWrapper() {
  return createDiv({
    style: styles.wrapper
  });
};

exports.createWrapper = createWrapper;

var createLoader = function createLoader() {
  var loader = createDiv({
    id: "loader",
    style: styles.loader.base,
    animate: {
      keyframes: styles.loader.keyframes,
      keyframeOptions: styles.loader.keyframeOptions
    }
  });
  return loader;
};

var createLoaderContainer = function createLoaderContainer() {
  var loaderDiv = createDiv({
    id: "loaderContainer",
    style: styles.loaderContainer
  });
  loaderDiv.appendChild(createLoader());
  return loaderDiv;
};

exports.createLoaderContainer = createLoaderContainer;

var createIframeContainer = function createIframeContainer() {
  return createDiv({
    style: styles.iframeContainer
  });
};

exports.createIframeContainer = createIframeContainer;